import Vue from 'vue';
import Vapi from "vuex-rest-api"

const api = new Vapi({
    axios: Vue.axios,
    state: {
        products: [],
        description: [],
        online: null,
        surcharge: 0,
        donaters: []
    }
})
    .get({
        action: "getSurcharge",
        property: "surcharge",
        path: ({login}) => `orders/current/${login}/`,
    })
    .get({
        action: "getProducts",
        property: "products",
        path: 'products/'
    })
    .get({
        action: "getDescription",
        property: "description",
        path: 'products/descriptions/'
    })
    .get({
        action: "getOnline",
        property: "online",
        path: 'online/',
    })
    .get({
        action: "getDonaters",
        property: "donaters",
        path: 'orders/latest/',
    })
    .get({
        action: "getDiscount",
        property: "discount",
        path: 'discount/',
    })
    .post({
        action: "buy",
        property: "buyResult",
        path: ({login, product}) => `/orders/?login=${login}&product=${product}`,
    })
    .getStore({namespaced: true});

export default {
    ...api,
    mutations: {
        resetSurcharge(s) {
            s.surcharge = 0;
        },
        ...api.mutations
    }
};
